import { CustomErrorType } from '../constants.mjs';

const HEADER_KEY_API_ACCESS_TOKEN = "x-flex-aid";
function isRouteChangeCanceledError(error) {
  return error === CustomErrorType.RouteChangeCanceled;
}
function isAccessTokenTypeError(error) {
  return error instanceof TypeError && error.message.includes(HEADER_KEY_API_ACCESS_TOKEN);
}

export { isAccessTokenTypeError, isRouteChangeCanceledError };
//# sourceMappingURL=customError.mjs.map
